<mat-drawer-container
  dir="rtl"
  (backdropClick)="closeSidenav()"
  [hasBackdrop]="['small', 'xSmall', 'medium'].includes(screenSize)"
  class="bg-white h-screen"
>
  <mat-drawer
    [mode]="
      ['small', 'xSmall', 'medium'].includes(screenSize) ? 'over' : 'side'
    "
    [opened]="!!menuIsOpen && !tableFullscreenIsOpen()"
  >
    <app-sidebar (clickCloseIcon)="closeSidenav()"></app-sidebar>
  </mat-drawer>
  <mat-drawer-content class="h-screen bg-background-default !overflow-hidden">
    @if (screenSize !== "xSmall") {
      <app-layout-header></app-layout-header>
    }
    <app-page-header [hidden]="hiddenHeader"></app-page-header>
    @if (!tableFullscreenIsOpen()) {
      <app-quick-access></app-quick-access>
    }
    <section
      class="page-content-box h-full"
      [ngClass]="{
        'page-content-box__large-screen': screenSize !== 'xSmall',
        'page-content-box__mobile-screen': screenSize === 'xSmall',
        '!pt-0 py-2': hiddenHeader,
      }"
    >
      <div
        id="main-content-wrapper"
        appDataTestId="main-content-wrapper"
        class="max-h-full min-h-[75dvh] !overflow-y-scroll pe-[6px]"
        [ngClass]="{
          'page-content-box__scrollbar': screenSize !== 'xSmall',
          'no-scrollbar': screenSize === 'xSmall',
          'min-h-[90dvh]': hiddenHeader,
        }"
      >
        <router-outlet></router-outlet>
      </div>
      @if (screenSize === "xSmall") {
        <app-mobile-navigation></app-mobile-navigation>
      }
    </section>
  </mat-drawer-content>
</mat-drawer-container>
